export const convertEventSelectToTarget = (name, value) => {
  return {
    target: {
      name,
      value,
    },
  };
};
